(() => {
  const state = {
    renderSeq: 0,
    isRendering: false,
  };

  async function render() {
    if (state.isRendering) return;
    state.isRendering = true;

    const seq = ++state.renderSeq;
    const container = document.getElementById('drawer-included-training');
    const wrapper = document.getElementById('CartDrawer-IncludedTraining');
    if (!container) { state.isRendering = false; return; }

    try {
      const cart = await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig() }).then(r => r.json());

      if (seq !== state.renderSeq) { state.isRendering = false; return; }

      const mapEl = document.getElementById('cart-kit-training-map');
      let map = {};
      try { map = JSON.parse(mapEl?.textContent || '{}'); } catch (_) {}

      const cartCountByHandle = {};
      (cart.items || []).forEach(i => {
        cartCountByHandle[i.handle] = (cartCountByHandle[i.handle] || 0) + i.quantity;
      });
      const prompts = [];

      Object.entries(map).forEach(([kitHandle, data]) => {
        if (!cartCountByHandle[kitHandle]) return;
        const missing = (data.training || []).filter(t => {
          const inCart = cartCountByHandle[t.handle] || 0;
          const required = t.required_qty || 1;
          return inCart < required;
        });
        if (!missing.length) return;
        prompts.push({ kitTitle: data.kit_title, kitUrl: data.kit_url, kitHandle, missing });
      });

      // Re-query after async gap — section may have re-rendered
      const freshContainer = document.getElementById('drawer-included-training');
      const freshWrapper = document.getElementById('CartDrawer-IncludedTraining');
      if (!freshContainer) { state.isRendering = false; return; }

      freshContainer.innerHTML = '';

      if (!prompts.length) {
        if (freshWrapper) freshWrapper.hidden = true;
        state.isRendering = false;
        return;
      }

      prompts.forEach(({ kitTitle, kitUrl, kitHandle, missing }) => {
        const names = missing.map(t => t.title).join(' and ');
        const anchor = `#kit-training-${kitHandle}`;
        const div = document.createElement('div');
        div.className = 'itd-drawer__prompt text-sm';
        div.innerHTML =
          `Your <strong>${kitTitle}</strong> includes <strong>${names}</strong>. ` +
          `Visit the kit page to choose your training dates. ` +
          `<a href="${kitUrl}${anchor}" class="link" style="text-decoration:underline;">Add training</a>`;
        freshContainer.appendChild(div);
      });

      if (freshWrapper) freshWrapper.hidden = false;
    } catch (e) {
      console.error('[Included Training Drawer]', e);
    } finally {
      state.isRendering = false;
    }
  }

  document.addEventListener('product-ajax:added', () => { render(); });
  document.addEventListener('cart:updated', () => { render(); });
  document.addEventListener('cart:open', () => { render(); });

  if (document.querySelector('cart-drawer')) {
    render();
  }
})();
